import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { stateOptions } from '../utils/states';

function StateField({ value, onChange }) {
  return (
    <select defaultValue={value} onChange={(e) => onChange(e.target.value)} className={classNames('form-select')} required>
      <option value="" disabled>
        Select...
      </option>
      {stateOptions.map((state) => (
        <option key={state.value} value={state.value}>
          {state.label}
        </option>
      ))}
    </select>
  );
}

StateField.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default StateField;
